import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import Navbar from '../components/shared/Navbar'
import HistoryContainer from '../components/history/HistoryContainer'

const HistoryPage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("history")} />
      <Navbar />
      <HistoryContainer />
    </>
  )
}

export default HistoryPage
